import React, { useEffect, useRef, useState } from 'react';
import '../../CSS/Global.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../SideBar';
import { useSidebar } from '../../SidebarContext';
import Header from '../Header';
import Select from 'react-select';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ImageModalEquip from '../Modal/ImageModalProd';
import ImageModalDownloadable from '../Modal/ImageModalDownloadble';
import ImageModalGallery from '../Modal/ImageModalGallery';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { X, EyeOff, Eye, Trash2 } from 'lucide-react';
import { decryptToken } from '../utils/getToken';

function convertToWords(num) {
    num = Number(num);
    if (isNaN(num) || num <= 0) return '';
    const a = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six',
        'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve',
        'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
        'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const numberToWords = (n) => {
        if (n < 20) return a[n];
        if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
        if (n < 1000) return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " and " + numberToWords(n % 100) : "");
        if (n < 100000) return numberToWords(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + numberToWords(n % 1000) : "");
        if (n < 10000000) return numberToWords(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + numberToWords(n % 100000) : "");
        return numberToWords(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 ? " " + numberToWords(n % 10000000) : "");
    };

    return numberToWords(Number(num));
}


const generateUniqueSKU = (() => {
    const usedSKUs = new Set();

    return () => {
        let sku;
        do {
            sku = 'SKU-' + Math.random().toString(36).substring(2, 10).toUpperCase();
        } while (usedSKUs.has(sku));
        usedSKUs.add(sku);
        return sku;
    };
})();


const VariableProduct = () => {
    const { isSidebarOpen } = useSidebar();
    const user = getDecryptedUserFromCookie("gta_mainstateuser");
    const [keyFeatureInput, setKeyFeatureInput] = useState('');
    const [specInput, setSpecInput] = useState({ label: '', value: '' });

    if (user) {
        console.log("✅ User:", user);
    } else {
        console.log("⚠️ User not found or decryption failed.");
    }
    const token = decryptToken("accessToken") || ""
    const [formData, setFormData] = useState({
        image: [],
        gallery: [],
        title: '',
        product_type: { value: 'Variable Product', label: 'Variable Product' },
        category: null,
        categorytype: [],
        status: null,
        stock: "",
        typeofsimple: "",
        short_description: "",
        description: "",
        attribute: [],
        variation: [],
        user_id: user.main_id,
        user_name: user.full_name,
        delivery_days: "",
        key_features: [],
        specifications: [],
        category_id: ""
    });
    const [availableSizes] = useState(["XS", "S", "M", "L", "XL", "XXL"]);
    const [selectedSizes, setSelectedSizes] = useState([]);
    const [variationsAccordion, setVariationsAccordion] = useState([]);
    const [showVariations, setShowVariations] = useState(false);
    const navigate = useNavigate();
    const [variationErrors, setVariationErrors] = useState({});

    console.log(formData)
    const [activeIndex, setActiveIndex] = useState(null);
    const toggleAccordion = (index) => {
        setActiveIndex(prevIndex => (prevIndex === index ? null : index));
    };

    const updateVariation = (index, field, value) => {
        setVariations(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };
            return updated;
        });
    };

    const searchListStyles = {
        container: {
            maxHeight: '250px',
            overflowY: 'auto',
            border: '1px solid #ddd',
            borderRadius: '8px',
            padding: '10px',
            backgroundColor: '#fff',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        },
        item: {
            display: 'flex',
            alignItems: 'center',
            padding: '10px',
            borderBottom: '1px solid #eee',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease',
        },
        itemHover: {
            backgroundColor: '#f8f9fa',
        },
        image: {
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            marginRight: '15px',
        },
        info: {
            display: 'flex',
            flexDirection: 'row',
            gap: "5px",
            alignItems: "center"
        },
        studentName: {
            fontWeight: '600',
            fontSize: '14px',
            marginBottom: '2px',
        },
        studentID: {
            fontSize: '12px',
            color: '#666',
        },
    };

    const attributeOptions = [
        { value: 'size', label: 'Size' },
        { value: 'weight', label: 'Weight' },
        { value: 'length', label: 'Length' },
        { value: 'thickness', label: 'Thickness' },
        // Add more as needed
    ];

    const sizeOptions = [
        { value: 'S', label: 'S' },
        { value: 'M', label: 'M' },
        { value: 'L', label: 'L' },
        { value: 'XL', label: 'XL' },
        { value: 'XXL', label: 'XXL' },
    ];

    const WeightOptions = [
        { value: '30 kg', label: '30 kg' },
        { value: '50 kg', label: '50 kg' },

    ]


    const [showImageModal, setShowImageModal] = useState(false);
    const [images, setImages] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [showImageModalGallery, setShowImageModalGallery] = useState(false);
    const [imagesGallery, setImagesGallery] = useState([]);
    const [categories, setCategories] = useState([]);

    const [isUploadModalOpen, setUploadModalOpen] = useState(false);


    const [variations, setVariations] = useState([]);
    const [variationDetails, setVariationDetails] = useState({});
    const [selectedImageVar, setSelectedImageVar] = useState(null); // For main product image
    const [showModalVar, setShowModalVar] = useState(false);
    const [showModalVar1, setShowModalVar1] = useState(false);
    const [imagesVar, setImagesVar] = useState([]);
    const [variationImages, setVariationImages] = useState({}); // Track selected images for each variation
    const [currentVariationId, setCurrentVariationId] = useState(null);
    const [variationGalleryImages, setVariationGalleryImages] = useState({});
    const [selectedAttributes, setSelectedAttributes] = useState([]);
    const [accordionsState, setAccordionsState] = useState({});
    const [attribute, setAttribute] = useState([]);
    const [filteredAttribute, setFilteredAttribute] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const url = process.env.REACT_APP_LINK

    const handleOpenModalVar = (variationId) => {
        setCurrentVariationId(variationId); // Set the variation ID
        setShowModalVar(true); // Open the modal
    };

    const handleCloseModalVar = () => {
        setShowModalVar(false);
    };

    const handleImageView = async () => {
        const all = await axios.get(`${url}/api/images/${user.main_id}`);
        setImages((all.data).reverse());
    }


    const fetchCategories = async () => {
        try {
            const response = await fetch(`${url}/category/getdata/category/${user.main_id}`, {
                method: "GET",
            });
            const res = await response.json();

            const options = res.map(cat => ({
                value: cat.category || cat.id,
                label: cat.category || cat.category || "Unnamed Category",
                id: cat.id
            }));

            // Add the dummy "Select" option at the top
            const withDummy = [{ value: "", label: "Select" }, ...options];

            setCategories(withDummy);
        } catch (error) {
            console.log(error);
        }
    };

    // const handleRemoveVariationImage = (variationId) => {
    //     setVariationImages((prevImages) => {
    //         const updatedImages = { ...prevImages };
    //         delete updatedImages[variationId];
    //         return updatedImages;
    //     });
    // };

    // const updateTypeofSimple = (key, isChecked) => {
    //     const currentTypes = formData.typeofsimple.split(',').filter(Boolean);
    //     let updatedTypes = isChecked
    //         ? [...new Set([...currentTypes, key])]
    //         : currentTypes.filter(type => type !== key);

    //     setFormData((prev) => ({
    //         ...prev,
    //         typeofsimple: updatedTypes.join(',')
    //     }));
    // };

    const updateTypeofSimple = (key, isChecked) => {
        let updatedTypes = formData.typeofsimple.split(',').filter(Boolean);

        if (key === 'virtual' && isChecked) {
            // Add 'virtual', remove 'downloadable'
            updatedTypes = ['virtual'];
        } else if (key === 'downloadable' && isChecked) {
            // Add 'downloadable', remove 'virtual'
            updatedTypes = ['downloadable'];
        } else {
            // Remove the key from selection
            updatedTypes = updatedTypes.filter(type => type !== key);
        }

        setFormData((prev) => ({
            ...prev,
            typeofsimple: updatedTypes.join(',')
        }));
    };

    // const updateTypeofCat = (key, isChecked) => {
    //     let updatedTypes = formData.categorytype.split(',').filter(Boolean);

    //     if (key === 'virtual' && isChecked) {
    //         // Add 'virtual', remove 'downloadable'
    //         updatedTypes = ['virtual'];
    //     } else if (key === 'downloadable' && isChecked) {
    //         // Add 'downloadable', remove 'virtual'
    //         updatedTypes = ['downloadable'];
    //     } else {
    //         // Remove the key from selection
    //         updatedTypes = updatedTypes.filter(type => type !== key);
    //     }

    //     setFormData((prev) => ({
    //         ...prev,
    //         categorytype: updatedTypes.join(',')
    //     }));
    // };

    const updateTypeofCat = (key, isChecked) => {
        let updatedTypes = [...formData.categorytype];

        if (isChecked) {
            if (!updatedTypes.includes(key)) updatedTypes.push(key);
        } else {
            updatedTypes = updatedTypes.filter(type => type !== key);
        }

        setFormData((prev) => ({
            ...prev,
            categorytype: updatedTypes
        }));
    };

    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];
    const [genrte, setGenerate] = useState(false)

    const categoryOptions = [
        { value: 'electronics', label: 'Electronics' },
        { value: 'fashion', label: 'Fashion' },
        { value: 'home', label: 'Home' },
        { value: 'books', label: 'Books' },
    ];

    const ProductOptions = [
        { value: 'Simple Product', label: 'Simple Product' },
        { value: 'Grouped Product', label: 'Grouped Product' },
        { value: 'External/Affiliate Product', label: 'External/Affiliate Product' },
        { value: 'Variable Product', label: 'Variable Product' },
    ];

    const StockOptions = [
        { value: 'In stock', label: 'In stock' },
        { value: 'Out of stock', label: 'Out of stock' },
        { value: 'Unlimited Stock', label: 'Unlimited Stock' },
    ];

    const handleChange1 = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({ ...prev, [id]: value }));
    };

    const handleSelectChange = (selectedOption, { name }) => {
        setFormData((prev) => ({
            ...prev,
            [name]: selectedOption,              // keeps {value: "Electronics", label: "Electronics", id: 5}
            category_id: selectedOption?.id || "" // 👈 stores actual id
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        let hasError = false;
        const newErrors = {};
        let firstErrorIndex = -1;
        let firstErrorLabel = "";

        variations.forEach((variation, index) => {
            const details = variationDetails[variation.id] || {};
            const regularPrice = parseFloat(details.price || 0);
            const salePrice = parseFloat(details.salePrice || 0);

            if (!isNaN(salePrice) && !isNaN(regularPrice) && salePrice > regularPrice) {
                hasError = true;
                newErrors[variation.id] = "Sale price cannot be greater than regular price.";
                if (firstErrorIndex === -1) {
                    firstErrorIndex = index;
                    firstErrorLabel = Object.values(variation.attributes).join(' & ') || `Variation #${index + 1}`;
                }
            }
        });

        setVariationErrors(newErrors);

        if (hasError) {
            toast.error(`Please correct the error in variation: "${firstErrorLabel}"`);
            setActiveIndex(firstErrorIndex); // Open the faulty accordion
            return;
        }

        // Submit data
        // console.log("✅ Submitting valid form data:", formData);
        try {
            const payload = {
                ...formData,
                image: formData.image[0]?.url || "",
                product_type: formData.product_type?.value || "", // ✅ Convert to string
                status: formData.status?.value || "",
                stock: formData.stock?.value || "",
                categorytype: Array.isArray(formData.categorytype)
                    ? formData.categorytype.join(',')
                    : formData.categorytype,
                category: formData.category?.value || "",
                user_id: user.main_id,
                user_name: user.full_name,
            };

            const response = await fetch(`${url}/variable-product/admin1997`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload)
            });
            const res = await response.json();
            if (response.ok) {
                navigate("/products")
                toast.success("Product added successfully", {
                    position: "top-center",
                    autoClose: 2000
                });
                console.log("Product submitted successfully");
            } else {
                toast.warning(res.message)
                console.error("Failed to submit product");
            }

        } catch (error) {
            console.error("Submission error:", error);
        }
    };





    const handleNavigate = (url) => {
        navigate(url)
    };


    const fetchDataAttribute = async () => {
        try {
            const response = await fetch(`${url}/attribute/getdata/${user.main_id}`)
            const res = await response.json();
            console.log(res);
            setAttribute(res);
        } catch (error) {
            console.log(error);
        }
    }

    const handleSearch = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        // console.log(query);
        if (query === '') {
            // If search query is empty, show all attributes
            setFilteredAttribute(attribute);
        } else {
            // If there is a search query, filter based on it
            const filtered = attribute.filter((attr) =>
                attr.name.toLowerCase().includes(query.toLowerCase())
            );
            setFilteredAttribute(filtered);
        }
    };
    const handleAttributeClick = (attribute) => {
        // Add the selected attribute to the selectedAttributes array
        setSelectedAttributes((prev) => [
            ...prev,
            { ...attribute, selectedTerms: [] },
        ]);
        setSearchQuery('');
        setFilteredAttribute([]);
        setAccordionsState((prevState) => ({
            ...prevState,
            [attribute.name]: true, // Open this accordion initially
        }));
    };

    const handleSelectAll = (e, attribute) => {
        e.preventDefault(); // ⛔ Prevent page reload
        const updatedAttributes = selectedAttributes.map((attr) =>
            attr.id === attribute.id
                ? { ...attr, selectedTerms: [...attr.associatedTerms] }
                : attr
        );
        setFormData({
            ...formData,
            attribute: updatedAttributes
        });
        setSelectedAttributes(updatedAttributes);
    };


    const handleDeselectAll = (e, attribute) => {
        e.preventDefault();
        const updatedAttributes = selectedAttributes.map((attr) =>
            attr.id === attribute.id
                ? { ...attr, selectedTerms: [] }
                : attr
        );
        setFormData({
            ...formData,
            attribute: updatedAttributes
        })
        setSelectedAttributes(updatedAttributes);
    };

    const toggleAttributeAccordion = (attrName) => {
        setAccordionsState((prev) => ({
            ...prev,
            [attrName]: !prev[attrName],
        }));
    };


    const handleTermClick = (attribute, term) => {
        const updatedAttributes = selectedAttributes.map((attr) => {
            if (attr.id === attribute.id) {
                const isSelected = attr.selectedTerms.includes(term);
                const updatedTerms = isSelected
                    ? attr.selectedTerms.filter((t) => t.id !== term.id)
                    : [...attr.selectedTerms, term];
                return { ...attr, selectedTerms: updatedTerms };
            }
            return attr;
        });
        setFormData({
            ...formData,
            attribute: updatedAttributes
        })
        setSelectedAttributes(updatedAttributes);
    };


    const handleVariationImageSelect = (variationId, image) => {
        if (!image?.url) {
            console.error("Invalid image:", image);
            return;
        }

        setVariations((prevVariations) =>
            prevVariations.map((variation) =>
                variation.id === variationId
                    ? { ...variation, imageUrl: image.url }
                    : variation
            )
        );

        setFormData((prevEquipment) => ({
            ...prevEquipment,
            variation: prevEquipment.variation.map((variation) =>
                variation.id === variationId
                    ? { ...variation, imageUrl: image.url }
                    : variation
            ),
        }));

        setVariationImages((prevImages) => ({
            ...prevImages,
            [variationId]: image, // Store the selected image per variation
        }));

        setShowModalVar(false);
    };

    const handleVariationGallerySelect = (variationId, images) => {
        if (!Array.isArray(images) || images.length === 0) {
            console.error("Invalid images:", images);
            return;
        }

        setVariationGalleryImages((prevImages) => {
            const existingImages = prevImages[variationId] || [];

            // Filter out duplicate images
            const uniqueNewImages = images.filter(
                (img) => !existingImages.some((existing) => existing.url === img.url)
            );

            return {
                ...prevImages,
                [variationId]: [...existingImages, ...uniqueNewImages], // Append unique images only
            };
        });

        setVariations((prevVariations) =>
            prevVariations.map((variation) =>
                variation.id === variationId
                    ? {
                        ...variation,
                        galleryImages: [
                            ...(variation.galleryImages || []),
                            ...images
                                .map((img) => img.url)
                                .filter((url) => !(variation.galleryImages || []).includes(url)), // Avoid duplicates
                        ],
                    }
                    : variation
            )
        );

        setFormData((prevEquipment) => ({
            ...prevEquipment,
            variation: prevEquipment.variation.map((variation) =>
                variation.id === variationId
                    ? {
                        ...variation,
                        galleryImages: [
                            ...(variation.galleryImages || []),
                            ...images
                                .map((img) => img.url)
                                .filter((url) => !(variation.galleryImages || []).includes(url)), // Avoid duplicates
                        ],
                    }
                    : variation
            ),
        }));

        setShowModalVar1(false);
    };


    const handleRemoveGalleryImage = (variationId, index) => {
        setVariationGalleryImages((prevImages) => {
            if (!Array.isArray(prevImages[variationId])) return prevImages;

            const updatedImages = [...prevImages[variationId]];
            updatedImages.splice(index, 1);

            return { ...prevImages, [variationId]: updatedImages };
        });

        setVariations((prevVariations) =>
            prevVariations.map((variation) =>
                variation.id === variationId
                    ? { ...variation, galleryImages: variation.galleryImages.filter((_, i) => i !== index) }
                    : variation
            )
        );

        setFormData((prevEquipment) => ({
            ...prevEquipment,
            variation: prevEquipment.variation.map((variation) =>
                variation.id === variationId
                    ? { ...variation, galleryImages: variation.galleryImages.filter((_, i) => i !== index) }
                    : variation
            ),
        }));
    };



    // Handle removing variation images
    const handleRemoveVariationImage = (variationId) => {
        setVariationImages((prevImages) => {
            const updatedImages = { ...prevImages };
            delete updatedImages[variationId];
            return updatedImages;
        });
    };
    // Utility function to generate random 6-character ID
    const generateRandomId = () => {
        return Math.random().toString(36).substr(2, 6);
    };

    // const handleVariationDetailChange = (id, field, value) => {

    //     setFormData((prevEquipment) => ({
    //         ...prevEquipment,
    //         variation: prevEquipment.variation.map(variation => {
    //             if (variation.id === id) {
    //                 return {
    //                     ...variation,
    //                     [field]: value // Update the specific field in the variation
    //                 };
    //             }
    //             return variation; // Return unchanged variation
    //         })
    //     }));

    //     setVariations((prevVariations) =>
    //         prevVariations.map((variation) => {
    //             if (variation.id === id) {
    //                 // Return a new object with the updated field
    //                 return {
    //                     ...variation,
    //                     [field]: value, // Update the specific field (e.g., price, stock)
    //                 };
    //             }
    //             return variation; // Return unchanged variation
    //         })
    //     );

    //     // Also update the variationDetails if needed (optional, depending on your requirements)
    //     setVariationDetails((prevState) => ({
    //         ...prevState,
    //         [id]: {
    //             ...prevState[id],
    //             [field]: value
    //         }
    //     }));

    // };
    // Function to get the cartesian product of selected terms

    const handleVariationDetailChange = (id, field, value) => {
        // Ensure sale price is not greater than regular price
        const updatedDetails = {
            ...variationDetails[id],
            [field]: value
        };

        const regularPrice = parseFloat(field === "price" ? value : updatedDetails.price);
        const salePrice = parseFloat(field === "salePrice" ? value : updatedDetails.salePrice);

        const newErrors = { ...variationErrors };

        if (!isNaN(salePrice) && !isNaN(regularPrice) && salePrice > regularPrice) {
            newErrors[id] = "Sale price cannot be higher than regular price.";
        } else {
            delete newErrors[id];
        }

        setVariationErrors(newErrors);

        // Update the main formData
        setFormData((prevEquipment) => ({
            ...prevEquipment,
            variation: prevEquipment.variation.map(variation => {
                if (variation.id === id) {
                    return {
                        ...variation,
                        [field]: value
                    };
                }
                return variation;
            })
        }));

        // Update the local variations state
        setVariations((prevVariations) =>
            prevVariations.map((variation) =>
                variation.id === id
                    ? { ...variation, [field]: value }
                    : variation
            )
        );

        // Update variation details state
        setVariationDetails((prevState) => ({
            ...prevState,
            [id]: updatedDetails
        }));
    };

    const cartesianProduct = (arrays) => {
        return arrays.reduce((acc, curr) => {
            return acc.flatMap(a => curr.map(c => [...a, c]));
        }, [[]]);
    };

    const handleGenerateVariations = (e) => {
        e.preventDefault(); // ⛔ Prevent page reload

        const termsArray = selectedAttributes.map(attribute =>
            attribute.selectedTerms.map(term => ({
                name: attribute.name, // ✅ make sure this matches your actual attribute key
                value: term.name
            }))
        );

        const combinations = cartesianProduct(termsArray);

        const newVariations = combinations.map(combination => {
            const variationId = generateRandomId();
            const sku = generateUniqueSKU(); // 👈 generate new SKU

            return {
                id: variationId,
                sku, // ✅ include SKU
                attributes: combination.reduce((acc, curr) => {
                    acc[curr.name] = curr.value;
                    return acc;
                }, {}),
                price: 0,
                salePrice: 0,
                stock: 0,
                imageUrl: ''
            };
        });

        setFormData((prev) => ({
            ...prev,
            variation: newVariations
        }));
        setVariations(newVariations);
    };



    const handleRemoveVariation = (id) => {
        setVariations(variations.filter(variation => variation.id !== id));
    };

    const handleDeleteAttribute = (attributeId) => {
        // Filter out the attribute with the given id
        const updatedAttributes = selectedAttributes.filter((attribute) => attribute.id !== attributeId);

        // Update the state with the filtered attributes
        setSelectedAttributes(updatedAttributes);
        setFormData({
            ...formData,
            attribute: updatedAttributes
        })

        // Optionally, if you're saving the changes to the backend, you can also call an API to delete the attribute here
        // await axios.delete(`${url}/api/attributes/${attributeId}`);
    };
    const handleSaveAttributes = (e, attribute) => {
        e.preventDefault();
        // You can save the selected terms here
        console.log('Selected Terms for', attribute.name, attribute.selectedTerms);
        // Close the accordion
        setAccordionsState((prevState) => ({
            ...prevState,
            [attribute.name]: false,
        }));
    };

    useEffect(() => {
        fetchDataAttribute();
        handleImageView();
        fetchCategories()
    }, [])


    return (
        <>

            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Variable Product</h1>
                    <Link to="/products" className="oms-add-btn">
                        View Product
                    </Link>
                    {/* <div className="property-dropdown-wrapper">
                                            <button className="oms-add-btn" onClick={() => setIsOpen(!isOpen)}>
                                                Add Products
                                            </button>
                                            {isOpen && (
                                                <ul className="property-dropdown-menu">
                                                    <li onClick={() => handleNavigate('/simple-product')}>
                                                        Simple Product
                                                    </li>
                                                    <li onClick={() => handleNavigate('/grouped-product')}>
                                                        Grouped Product
                                                    </li>
                                                    <li onClick={() => handleNavigate('/grouped-product')}>
                                                        Grouped Product
                                                    </li>
                                                    <li onClick={() => handleNavigate('/external-affiliate-product')}>
                                                        Affiliate Product
                                                    </li> 
                                                    <li onClick={() => handleNavigate('/variable-product')}>
                                                        Variable Product
                                                    </li>
                                                </ul>
                                            )}
                                        </div> */}
                </div>
                <form className="oms-modal-form property-form"
                    // className="oms-modal-form"
                    onSubmit={handleSubmit}
                >


                    <div className='oms-givepaddingfrom'>
                        {/* <div className="oms-form-group">
                            <label htmlFor="category" className="oms-form-label">
                                Product Type
                            </label>
                            <Select
                                options={ProductOptions}
                                placeholder="Select Product Type"
                                name="product_type"
                                value={formData.product_type}
                                isDisabled
                            />
                        </div> */}
                        {/* Image Upload */}
                        <div className="oms-form-group">
                            <label htmlFor="title" className="oms-form-label">
                                Name
                            </label>
                            <input
                                type="text"
                                id="title"
                                placeholder="Enter title"
                                value={formData.title}
                                onChange={handleChange1}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="description" className="oms-form-label">
                                Short  Description
                            </label>
                            <ReactQuill
                                theme="snow"
                                value={formData.short_description}
                                onChange={(value) =>
                                    setFormData((prev) => ({ ...prev, short_description: value }))
                                }
                                placeholder="Enter Short Description"
                            />
                        </div>


                        <div className="oms-form-group">
                            <label htmlFor="description" className="oms-form-label">
                                Description
                            </label>
                            <ReactQuill
                                theme="snow"
                                value={formData.description}
                                onChange={(value) =>
                                    setFormData((prev) => ({ ...prev, description: value }))
                                }
                                style={{ backgroundColor: "#fefffc" }}
                                placeholder="Enter Description"
                            />
                        </div>

                        {/* Product Image Upload */}
                        <div className="oms-form-group">
                            <label className="oms-form-label">Product Image</label>

                            {/* Button to open image modal */}
                            <button
                                type="button"
                                className="image-upload-btn"
                                onClick={() => setShowImageModal(true)}
                            >
                                Choose Image
                            </button>


                            {/* Preview selected image */}
                            {formData.image.length > 0 && (
                                <div className="selected-image-preview">
                                    <img
                                        src={formData.image[0]?.url ? `${url}${formData.image[0].url}` : formData.image[0]}
                                        alt="Selected"
                                    />
                                    <p
                                        className='delete-btnomsprod'
                                        onClick={() => setFormData((prev) => ({ ...prev, image: [] }))}

                                    >
                                        <i class="fa-solid fa-xmark"></i>
                                    </p>
                                </div>
                            )}
                        </div>

                        <ImageModalEquip
                            show={showImageModal}
                            handleClose={() => setShowImageModal(false)}
                            images={images}
                            onImageSelect={(img) =>
                                setFormData((prev) => ({ ...prev, image: [img] }))
                            }
                            multiple={false}
                            setImages={setImages}
                        />

                        <div className="oms-form-group">
                            <label className="oms-form-label">Product Gallery</label>
                            <button
                                type="button"
                                className="image-upload-btn"
                                onClick={() => setShowImageModalGallery(true)}
                            >
                                Add Gallery Images
                            </button>

                            {/* Preview selected gallery images */}
                            <div className="gallery-preview">
                                {formData.gallery.map((img, index) => (
                                    <div key={index} style={{ display: 'inline-block', marginRight: 10, position: 'relative' }}>
                                        <img
                                            src={img?.url ? `${url}${img.url}` : img}
                                            alt="gallery"
                                            className='gallery-preview-image'
                                        // style={{ width: "80px", height: "80px", objectFit: "cover", border: "1px solid #ccc" }}
                                        />
                                        <p
                                            type="button"
                                            className='delete-btnomsprod'
                                            onClick={() => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    gallery: prev.gallery.filter((_, i) => i !== index)
                                                }));
                                            }}

                                        >
                                            <i class="fa-solid fa-xmark"></i>
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <ImageModalGallery
                            show={showImageModalGallery}
                            handleClose={() => setShowImageModalGallery(false)}
                            images={images}
                            multiple={true} // ⬅️ set to true for gallery
                            setImages={setImages}
                            onImageSelect={(imgs) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    gallery: Array.isArray(imgs) ? [...prev.gallery, ...imgs] : [...prev.gallery, imgs]
                                }));
                            }}
                        />

                        <div className="oms-form-group oms-attr-form-group">
                            <label className="oms-form-label oms-attr-form-label">Select Attributes</label>
                            <input
                                type="text"
                                value={searchQuery}
                                onChange={handleSearch}
                                placeholder="Enter attribute (e.g., Color, Size)"
                                className="oms-attr-search-input"
                            />
                            {filteredAttribute.length > 0 && (
                                <div style={searchListStyles.container} className="oms-attr-search-dropdown">
                                    {filteredAttribute.map((attr) => (
                                        <div
                                            key={attr.id}
                                            style={searchListStyles.item}
                                            className="oms-attr-search-item"
                                            onClick={() => handleAttributeClick(attr)}
                                        >
                                            <span style={searchListStyles.studentName} className="oms-attr-search-name">{attr.name}</span>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {selectedAttributes.map((attribute) => (
                                <div key={attribute.id} className="accordion mt-3 oms-attr-accordion">
                                    <div className="accordianinside oms-attr-accordion-inner">
                                        <h5 className="attributenamedisplay oms-attr-title">{attribute.name}</h5>
                                        <div className="attributecloseexpand oms-attr-controls">
                                            <span
                                                className="oms-attr-expand-btn toggle-icon-btn"
                                                onClick={() => toggleAttributeAccordion(attribute.name)}
                                            >
                                                {accordionsState[attribute.name] ? <EyeOff size={22} /> : <Eye size={22} />}
                                            </span>

                                            <span
                                                className="oms-attr-delete-btn"
                                                onClick={() => handleDeleteAttribute(attribute.id)}
                                            >
                                                <Trash2 size={22} />
                                            </span>
                                        </div>
                                    </div>

                                    {accordionsState[attribute.name] && (
                                        <div className="valuewatch oms-attr-value-box">
                                            <p>Value(s):</p>
                                            <div className="term-selection oms-attr-term-list">
                                                {attribute.associatedTerms.map((term) => (
                                                    <span
                                                        key={term.id}
                                                        className={`term-item oms-attr-term-item ${attribute.selectedTerms.includes(term) ? 'selected' : ''}`}
                                                        onClick={() => handleTermClick(attribute, term)}
                                                    >
                                                        {term.name}
                                                    </span>
                                                ))}
                                            </div>
                                            <div className="threebuttontogether mt-3 oms-attr-actions">
                                                {attribute.associatedTerms.length > 0 && (
                                                    <>
                                                        {attribute.selectedTerms.length < attribute.associatedTerms.length ? (
                                                            <button
                                                                type="button"
                                                                className="me-2 oms-attr-btn-selectall"
                                                                onClick={(e) => handleSelectAll(e, attribute)}
                                                            >
                                                                Select all
                                                            </button>
                                                        ) : (
                                                            <button
                                                                type="button"
                                                                className="me-2 oms-attr-btn-deselectall"
                                                                onClick={(e) => handleDeselectAll(e, attribute)}
                                                            >
                                                                Select none
                                                            </button>
                                                        )}
                                                    </>
                                                )}

                                                <button
                                                    type="button"
                                                    className="oms-attr-btn-save"
                                                    onClick={(e) => handleSaveAttributes(e, attribute)}
                                                >
                                                    Save attributes
                                                </button>
                                            </div>

                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        <div className="variation-wrapper oms-attr-variation-wrapper">
                            {selectedAttributes.length > 0 && selectedAttributes.every(attr => attr.selectedTerms.length > 0) && (
                                <button
                                    type="button"
                                    className="btn-generate oms-attr-generate-btn"
                                    onClick={(e) => handleGenerateVariations(e)}
                                >
                                    Generate Variations
                                </button>
                            )}

                            {variations.length > 0 && (
                                <div className="accordion-list oms-attr-variation-list">
                                    {variations.map((variation, index) => (
                                        <div className="accordion-item oms-attr-variation-item" key={variation.id}>
                                            <div className="accordion-header oms-attr-variation-header" onClick={() => toggleAccordion(index)}>
                                                <div className="accordion-title oms-attr-variation-title">
                                                    <strong>#{variation.id}</strong> - {Object.values(variation.attributes).join(' & ')}
                                                </div>
                                                <span className="remove-btn oms-attr-remove-variation-btn" onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleRemoveVariation(variation.id);
                                                }}>Remove</span>
                                            </div>

                                            {activeIndex === index && (
                                                <div className="accordion-body oms-attr-variation-body">
                                                    <div className="form-group oms-attr-img-group">
                                                        <label>Product Image</label>
                                                        {!variationImages[variation.id] ? (
                                                            <input
                                                                type="text"
                                                                readOnly
                                                                placeholder="Choose image"
                                                                onClick={() => handleOpenModalVar(variation.id)}
                                                                className="oms-attr-img-input"
                                                            />
                                                        ) : (
                                                            <div className="image-preview oms-attr-img-preview">
                                                                <img
                                                                    src={`${url}${variationImages[variation.id]?.url}`}
                                                                    alt="Selected"
                                                                    width={100}
                                                                    height={100}
                                                                    onClick={() => handleOpenModalVar(variation.id)}
                                                                />
                                                                <p className="remove-link oms-attr-img-remove" onClick={() => handleRemoveVariationImage(variation.id)}>
                                                                    Remove product image
                                                                </p>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="form-group oms-attr-gallery-group">
                                                        <label>Product Gallery</label>
                                                        <input
                                                            type="text"
                                                            readOnly
                                                            placeholder="Choose gallery"
                                                            onClick={() => setShowModalVar1(true)}
                                                            className="oms-attr-gallery-input"
                                                        />
                                                        <div className="gallery-preview oms-attr-gallery-preview">
                                                            {Array.isArray(variationGalleryImages[variation.id]) && variationGalleryImages[variation.id].map((img, idx) => (
                                                                <div key={idx} className="gallery-img oms-attr-gallery-img">
                                                                    <img
                                                                        src={`${url}${img.url}`}
                                                                        alt="Gallery"
                                                                        width={80}
                                                                        height={80}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        className="remove-btn oms-attr-gallery-remove"
                                                                        onClick={() => handleRemoveGalleryImage(variation.id, idx)}
                                                                    >
                                                                        <i className="fa-solid fa-xmark"></i>
                                                                    </button>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>

                                                    <div className="form-row oms-attr-pricing-row">
                                                        <div className="form-group oms-attr-price-group">
                                                            <label>Regular Price:</label>
                                                            <input
                                                                type="number"
                                                                placeholder="Price"
                                                                value={variationDetails[variation.id]?.price || ''}
                                                                onChange={(e) => handleVariationDetailChange(variation.id, 'price', e.target.value)}
                                                                onWheel={(e) => e.target.blur()}
                                                            />
                                                        </div>

                                                        <div className="form-group oms-attr-saleprice-group">
                                                            <label>Sale Price:</label>
                                                            <input
                                                                type="number"
                                                                placeholder="Sale Price"
                                                                value={variationDetails[variation.id]?.salePrice || ''}
                                                                onChange={(e) => handleVariationDetailChange(variation.id, 'salePrice', e.target.value)}
                                                                onWheel={(e) => e.target.blur()}
                                                                style={{ borderColor: variationErrors[variation.id] ? 'red' : undefined }}
                                                            />
                                                            {variationErrors[variation.id] && (
                                                                <div style={{ color: 'red', fontSize: '12px' }}>
                                                                    {variationErrors[variation.id]}
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="form-group oms-attr-sku-group">
                                                            <label>SKU:</label>
                                                            <input
                                                                type="text"
                                                                placeholder="SKU"
                                                                value={(variationDetails[variation.id]?.sku || variation.sku)?.toUpperCase()}
                                                                onChange={(e) =>
                                                                    handleVariationDetailChange(variation.id, 'sku', e.target.value.toUpperCase())
                                                                }
                                                            />
                                                        </div>

                                                        <div className="form-group oms-attr-stock-group">
                                                            <label>Stock:</label>
                                                            <input
                                                                type="number"
                                                                placeholder="Stock"
                                                                value={variationDetails[variation.id]?.stock || ''}
                                                                onChange={(e) => handleVariationDetailChange(variation.id, 'stock', e.target.value)}
                                                                onWheel={(e) => e.target.blur()}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}

                            <ImageModalEquip
                                show={showModalVar}
                                handleClose={handleCloseModalVar}
                                images={images}
                                onImageSelect={(image) => handleVariationImageSelect(currentVariationId, image)}
                                multiple={false}
                                setImages={setImages}
                            />
                            <ImageModalGallery
                                show={showModalVar1}
                                handleClose={() => setShowModalVar1(false)}
                                images={images}
                                onImageSelect={(imgs) => handleVariationGallerySelect(currentVariationId, imgs)}
                                multiple={true}
                                setImages={setImages}
                            />
                        </div>


                        <div className="oms-form-group">
                            <label htmlFor="category" className="oms-form-label">
                                Stock Status
                            </label>
                            <Select
                                options={StockOptions}
                                placeholder="Select Stock Status"
                                name="stock"
                                value={formData.stock}
                                onChange={handleSelectChange}
                            />
                        </div>



                        {/* Key Features */}
                        <div className="oms-form-group ome-form-button2">
                            <label className="oms-form-label">Key Features</label>
                            <div>
                                <input
                                    type="text"
                                    className="oms-input"
                                    placeholder="Enter key feature"
                                    value={keyFeatureInput}
                                    onChange={(e) => setKeyFeatureInput(e.target.value)}
                                />
                                <button
                                    type="button"
                                    className="oms-add-btn"
                                    onClick={() => {
                                        if (keyFeatureInput.trim()) {
                                            setFormData((prev) => ({
                                                ...prev,
                                                key_features: [...prev.key_features, keyFeatureInput.trim()],
                                            }));
                                            setKeyFeatureInput('');
                                        }
                                    }}
                                    style={{ marginTop: "10px" }}
                                >
                                    Add More
                                </button>
                            </div>
                            <ul className="oms-tag-list">
                                {formData.key_features.map((feature, index) => (
                                    <li key={index} className="oms-tag-item">
                                        {feature}
                                        <X
                                            type="button"
                                            className="oms-tag-delete"
                                            onClick={() => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    key_features: prev.key_features.filter((_, i) => i !== index),
                                                }));
                                            }}
                                            size={14}
                                        />
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Specifications */}
                        <div className="oms-form-group ome-form-button2">
                            <label className="oms-form-label">Specifications</label>
                            <div style={{ display: "flex", gap: "10px", marginBottom: "10px", flexWrap: "wrap" }}>
                                <input
                                    type="text"
                                    className="oms-input"
                                    placeholder="Label"
                                    value={specInput.label}
                                    onChange={(e) => setSpecInput((prev) => ({ ...prev, label: e.target.value }))}
                                />
                                <input
                                    type="text"
                                    className="oms-input"
                                    placeholder="Value"
                                    value={specInput.value}
                                    onChange={(e) => setSpecInput((prev) => ({ ...prev, value: e.target.value }))}
                                />
                                <button
                                    type="button"
                                    className="oms-add-btn"
                                    onClick={() => {
                                        if (specInput.label.trim() && specInput.value.trim()) {
                                            setFormData((prev) => ({
                                                ...prev,
                                                specifications: [...prev.specifications, specInput],
                                            }));
                                            setSpecInput({ label: '', value: '' });
                                        }
                                    }}
                                >
                                    Add More
                                </button>
                            </div>

                            <ul className="oms-tag-list">
                                {formData.specifications.map((spec, index) => (
                                    <li key={index} className="oms-tag-item">
                                        <strong>{spec.label}:</strong> {spec.value}
                                        <X
                                            type="button"
                                            className="oms-tag-delete"
                                            onClick={() => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    specifications: prev.specifications.filter((_, i) => i !== index),
                                                }));
                                            }}
                                            size={14}
                                        />
                                    </li>
                                ))}
                            </ul>
                        </div>
                        {/* Category */}
                        <div className="oms-form-group">
                            <label htmlFor="category" className="oms-form-label">
                                Category
                            </label>
                            <Select
                                options={categories}
                                placeholder="Select category"
                                name="category"
                                value={formData.category}
                                onChange={handleSelectChange}
                            />
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">Choose Home Category</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Best Sellers"
                                        checked={formData.categorytype.includes("Best Sellers")}
                                        onChange={(e) => updateTypeofCat("Best Sellers", e.target.checked)}
                                    />
                                    <label htmlFor="Best Sellers">Best Sellers</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Trending"
                                        checked={formData.categorytype.includes("Trending")}
                                        onChange={(e) => updateTypeofCat("Trending", e.target.checked)}
                                    />

                                    <label htmlFor="Trending">Trending</label>
                                </div>
                            </div>
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="delivery_days" className="oms-form-label">
                                Delivery Days
                            </label>
                            <input
                                type="number"
                                id="delivery_days"
                                placeholder="Enter Delivery within days"
                                value={formData.delivery_days}
                                onChange={handleChange1}
                                onWheel={(e) => e.target.blur()}
                            />
                        </div>

                        {/* Status */}
                        <div className="oms-form-group">
                            <label htmlFor="status" className="oms-form-label">
                                Status
                            </label>
                            <Select
                                options={statusOptions}
                                placeholder="Select status"
                                name="status"
                                value={formData.status}
                                onChange={handleSelectChange}
                            />
                        </div>

                        {/* Actions */}


                        <div className="oms-form-actions">
                            <button type="submit" className='post-property-submit'>Submit</button>
                        </div>
                    </div>

                </form >
            </div >
        </>
    );
};

export default VariableProduct;


const DownloadableFiles = () => {
    const [files, setFiles] = useState([{ name: '', url: '', file: null }]);
    const [showImageModal, setShowImageModal] = useState(false);
    const [images, setImages] = useState([]);

    const handleAddFile = () => {
        setFiles([...files, { name: '', url: '', file: null }]);
    };

    const handleRemoveFile = (index) => {
        const updatedFiles = files.filter((_, i) => i !== index);
        setFiles(updatedFiles);
    };

    const handleChange = (index, field, value) => {
        const updatedFiles = [...files];
        updatedFiles[index][field] = value;
        setFiles(updatedFiles);
    };

    return (
        <div className="downloadable-section">
            {/* <h4>Downloadable files</h4> */}
            <div className="file-input-table">
                {files.map((file, index) => (
                    <div className="file-row" key={index}>
                        <input
                            type="text"
                            placeholder="File name"
                            value={file.name}
                            onChange={(e) => handleChange(index, 'name', e.target.value)}
                        />
                        <input
                            type="text"
                            placeholder="http://"
                            value={file.url}
                            onChange={(e) => handleChange(index, 'url', e.target.value)}
                        />
                        <button
                            type="button"
                            onClick={() => setShowImageModal(true)}
                        >
                            Choose file
                        </button>
                        <input
                            id={`fileInput-${index}`}
                            type="file"
                            style={{ display: 'none' }}
                            onChange={(e) => handleChange(index, 'file', e.target.files[0])}
                        />
                        <button
                            type="button"
                            className="remove-btn"
                            onClick={() => handleRemoveFile(index)}
                        >
                            <i class="fa-solid fa-xmark"></i>
                        </button>
                        <ImageModalDownloadable
                            show={showImageModal}
                            handleClose={() => setShowImageModal(false)}
                            images={images}
                            // onImageSelect={(img) =>
                            //     setFormData((prev) => ({ ...prev, image: [img] }))
                            // }
                            multiple={false}
                            setImages={setImages}
                        />
                    </div>
                ))}
                <button className="add-btn" type="button" onClick={handleAddFile}>
                    Add File
                </button>
            </div>
        </div>
    );
};